import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import { Box, Chip, Stack, Typography, useTheme } from '@mui/material';

import { getGetTalentProcessesQueryKey } from '@/api/generated';
import ProcessStatusIcon from '@/components/ProcessStatusIcon';
import TalentProcessActionsMenu from '@/components/TalentProcessActionsMenu';
import { toProcess } from '@/root/linker';

import { useTalentProcessContext } from './TalentProcessContext';

const ProcessTitle = () => {
  const { spacing, typography } = useTheme();
  const { process, talent } = useTalentProcessContext();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const handleRemoveSuccess = useCallback(() => {
    queryClient.invalidateQueries(getGetTalentProcessesQueryKey(talent.id!));
  }, [talent.id, queryClient]);

  return (
    <>
      <Stack
        component={Link}
        to={toProcess({ processId: process.id! })}
        direction="row"
        alignItems="center"
        sx={{ textDecoration: 'none' }}
      >
        <ProcessStatusIcon status={process.status} />
        <Typography
          variant="body1"
          marginInlineStart={spacing(0.5)}
          fontWeight={typography.fontWeightMedium}
          lineHeight={spacing(3)}
          color="text.primary"
        >
          {process.name}
        </Typography>
        <Chip
          variant="tag"
          label={t(`processes:layouts.processes.details.info.processTypes.${process.assessmentType?.toLowerCase()}`)}
          sx={{ marginInlineStart: spacing(1) }}
        />
      </Stack>
      <Box sx={{ marginInlineStart: 'auto' }}>
        <TalentProcessActionsMenu process={process} talent={talent} onRemoveSuccess={handleRemoveSuccess} />
      </Box>
    </>
  );
};

export default ProcessTitle;
